const { Entity } = require('./entity')

class Customer extends Entity {
  constructor (quickbooks, query) {
    super(quickbooks, 'Customer')
    this.query = query
  }

  /**
   * @param {string[]} customerIds
   * @param {string} companyCode
   */
  getList (customerIds, companyCode) {
    if (!customerIds || !customerIds.length) {
      return []
    }

    return this.query.send({
      companyCode,
      type: 'Customer',
      where: `Id in (${[...customerIds].map(id => `'${id}'`).join(',')})`,
      maxResults: 500
    })
  }
}

module.exports = {
  Customer
}
